import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { toast } from 'react-toastify';
import { CaSearchFilter } from './CaSearchFilter';
import { CaSearchDataTable } from './CaSearchDataTable';
import AskCreateTemplateIcon from '../../../assets/DisputeNotification.png';
import { Tabindex } from '../../../utils/typeConstants';
import {
    useGetCaTemplateQuery,
    useInsertCreateActionTemplateMutation
} from '../../../pages/correctiveActions/correctiveActionsSlice'
import { ControlDialogBox } from '../../../components/controlDialogBox/ControlDialogBox';
import { Template,Country,Category,Role } from '../type'
import './CaSearchTemplate.scss';


interface CaSearchTemplatePropTypes {
    selectedCountry: Country,
    selectedCategory: Category,
    selectedRole: Role,
    resetFilter: () => void;
    setActiveIndex: (e: number) => void;
    setSelectedCountry: (e: Country) => void;
    setSelectedCategory: (e: Category) => void;
    setSelectedRole: (e: Role) => void;
    setSelectedCaTemplate: (e: Template) => void;
    setIsUpdateApprovalQueues:(e: boolean) => void;
    setSelectedLanguage: (e:number) => void;
}

export const CaSearchTemplate = ({
    selectedCountry,
    selectedCategory,
    selectedRole,
    setSelectedCountry,
    setSelectedCategory,
    setSelectedRole,
    setSelectedCaTemplate,
    resetFilter,
    setActiveIndex,
    setIsUpdateApprovalQueues,
    setSelectedLanguage
}: CaSearchTemplatePropTypes) => {

    const [askcreateTempDialogVisible, setAskcreateTempDialogVisible] = useState<boolean>(false);   
    const [searchedTemplatesData, setSearchedTemplatesData] = useState<any>([]);
    const [insertCreateActionTemplate] = useInsertCreateActionTemplateMutation();

    const { data: caTemplateData } = useGetCaTemplateQuery({
        countryId: selectedCountry?.country_id,
        categoryId: selectedCategory?.ca_category_id,
        scorecardRoleId: selectedRole?.scorecard_role_id,
    },
        { skip: !selectedCountry?.country_id || !selectedCategory?.ca_category_id || !selectedRole?.scorecard_role_id }
    );

    const askCreateTempDialogFuncMap = {
        askCreateTempDialogBox: setAskcreateTempDialogVisible,
    };

    const onAskCreateTempDialogBoxHide = () => {
        askCreateTempDialogFuncMap.askCreateTempDialogBox(false);
    };

    const handleClickCancel = () => {
        onAskCreateTempDialogBoxHide();
    };

    const handleClickYes = () => {
        const templateName = `${selectedCountry?.country_name}-${selectedCategory?.ca_category_name}-${selectedRole?.scorecard_role_name}`;
        const templateData = {
            "ca_template_name": templateName
        }
        setSelectedCaTemplate(templateData);

        const caCreateTemplateData = {
            "ca_template_name": templateName,
            "country_id": selectedCountry?.country_id,
            "ca_category_id": selectedCategory?.ca_category_id,
            "scorecard_role_id": selectedRole?.scorecard_role_id
        };
        InsertCATemplateData(caCreateTemplateData);       
        onAskCreateTempDialogBoxHide();
    };

    const InsertCATemplateData = (caCreateTemplateData: any) => {       
        insertCreateActionTemplate(caCreateTemplateData)
            .unwrap()
            .then((data: any) => {
                if (data?.data) {
                    //active create tab here
                    setActiveIndex(Tabindex.Create);
                    return true;
                }
                return toast.error('Create corrective action template failed');
            });
    }

    useEffect(() => {
        if (Object.keys(selectedCountry).length !== 0 &&
            Object.keys(selectedCategory).length !== 0 &&
            Object.keys(selectedRole).length !== 0) {
            if (caTemplateData?.data.length > 0) {
                setSearchedTemplatesData(caTemplateData?.data);               
                const template = {
                    "ca_template_id":caTemplateData?.data[0]?.ca_template_id,
                    "ca_template_name":caTemplateData?.data[0]?.ca_template_name,
                }
                setSelectedCaTemplate(template);                
            }
            else {                
                setSearchedTemplatesData([]);
                setAskcreateTempDialogVisible(true);
            }

        }
        else {
            setSearchedTemplatesData([]);
        }
    }, [caTemplateData])

    const createFooterTemplate = (
        <div className='row'>
            <div className='col-md-2'>&nbsp;</div>
            <div className="col-md-4">
                <Button
                    className="btn-secondary w-100"
                    onClick={handleClickCancel}
                    label={"Cancel"}
                />
            </div>
            <div className="col-md-4">
                <Button
                    className="btn-primary w-100"
                    onClick={handleClickYes}
                    label={"Yes"}
                />
            </div>
            <div className='col-md-2'>&nbsp;</div>
        </div>
    );

    return (
        <div className="card border-0 p-3 ps-0">
            <div className="card-body p-0">
                <div className='row'>
                    <CaSearchFilter
                        selectedCountry={selectedCountry}
                        selectedCategory={selectedCategory}
                        selectedRole={selectedRole}
                        setSelectedCountry={setSelectedCountry}
                        setSelectedCategory={setSelectedCategory}
                        setSelectedRole={setSelectedRole}
                        filterDisable={false}
                    />
                    <div className='row mt-3'>
                        <div className='col-md-8'>&nbsp;</div>
                        <div className='col-md-4'>
                            <div className='row'>
                                <div className='col-md-8'>&nbsp;</div>
                                <div className='col-md-3'>
                                    <Button
                                        label="Reset"
                                        // style={{
                                        //     fontWeight: 400,
                                        // }}
                                        className="btn-secondary"
                                        onClick={() => { setSearchedTemplatesData([]); resetFilter(); }}
                                    />
                                </div>
                            </div>
                        </div>

                    </div>
                    <hr className="solid" />
                    <div className='row my-2'>
                        {searchedTemplatesData?.length > 0 ?
                            <CaSearchDataTable
                                searchedTemplatesData={searchedTemplatesData}
                                setActiveIndex={setActiveIndex}
                                setSelectedCountry={setSelectedCountry}
                                setSelectedCategory={setSelectedCategory}
                                setSelectedRole={setSelectedRole}
                                setSelectedCaTemplate={setSelectedCaTemplate}
                                setIsUpdateApprovalQueues={setIsUpdateApprovalQueues}
                                setSelectedLanguage={setSelectedLanguage}
                            /> :
                            <div />
                        }
                    </div>
                </div>
            </div>
            <ControlDialogBox
                dialogVisibile={askcreateTempDialogVisible}
                IconPath={AskCreateTemplateIcon}
                footerTemplate={createFooterTemplate}
                subHeading={"No results"}
                subHeadingColor={"#7D71E2"}
                msgText={"No template found,Do you want to create one?"}
                onDialogBoxHide={onAskCreateTempDialogBoxHide}
            />
        </div>
    )
}
